import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/transaksi/:tahun?/:bulan?/:hari?/:bayar?/:lokasi?/:loket?',
    name: 'transaksi',
    component: () => lazyLoadView(import('@views/admin/transaksi/List.vue')),
    meta: {
      title: 'Transaksi',
    },
  },
];
